/* client */
import { cfg } from '../../../config';
import { http } from '../http';
import { type ApiRsp } from '../types';

interface ClientService {
    GetApp(code?: string): Promise<ApiRsp>;
    // dropdown
    setAppDropdown(elm: HTMLSelectElement): Promise<void>;
}

export const client: ClientService = {
    GetApp: (code?: string) => {
        let url = cfg.hub.API + `/client`;
        if (code) url += `/${code}`;
        return http.get(url);
    },
    setAppDropdown: async (elm: HTMLSelectElement) => {
        const resp = await client.GetApp();
        const data = resp.data as AppClient[];
        data.forEach(val => {
            const option = document.createElement('option');
            option.value = val.client_id;
            option.textContent = val.client_name;
            elm.appendChild(option);
        });
    }
};

export type AppClient = {
    id: number;
    client_id: string;
    client_name: string;
    client_type: string;
    redirect_uri: string;
    grant_type: string;
    latest: string;
    logfile: string;
    isActive: boolean;
};